export enum ENotFound {
    ROUTE = 'ROUTE',
    USER = 'USER'
}

export interface INotFound {
    type?: ENotFound
}